<template>
  <div>
    <p>
      是否会员:
      <el-tag v-if="row.user_id" type="success" size="mini" effect="dark">是</el-tag>
      <el-tag v-else type="danger" size="mini" effect="dark">否</el-tag>
    </p>
    <p>
      是否订单:
      <el-tag v-if="row.order_id" type="success" size="mini" effect="dark">是</el-tag>
      <el-tag v-else type="danger" size="mini" effect="dark">否</el-tag>
    </p>
  </div>
</template>

<script>
export default {
  name: 'UserOrder',
  components: { },
  props: {
    row: {
      type: Object,
      required: true
    },
    prop: {
      type: String,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/company_risks/common/UserOrder.vue